import axios from 'axios';

export async function googleRequest(path, body, method = 'POST') {
  const token = localStorage.getItem('token');
  const { data } = await axios({
    url: `/api/auth/social${path}`, method, data: body, withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return data;
}

export function googleError(error) {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : detail?.message || 'Det gick inte att slutföra. Försök igen.';
}

export async function startGoogleAuth({ mode = 'auth', next = '/' } = {}) {
  const result = await googleRequest(mode === 'link' ? '/google/link/start' : '/google/start', { mode, next });
  window.location.assign(result.url);
}
